import { useTranslation } from 'react-i18next'
import { Outlet, useNavigate } from 'react-router'
import { Button } from 'src/components/button'

export const SubLayout = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <>
      {/* Sticky back button header */}
      <div className="bg-surface-hover/95 sticky top-0 z-sticky flex shrink-0 items-center rounded-xl p-4 shadow-sm backdrop-blur-sm">
        <Button variant="text" tone="primary" onClick={() => navigate(-1)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
          <span className="ml-2">{t('common.back')}</span>
        </Button>
      </div>
      {/* Form content */}
      <div className="pt-4">
        <Outlet />
      </div>
    </>
  )
}
